// extracted by mini-css-extract-plugin
export var sliderRange = "_ca-2";
export var sliderRoot = "_ca-0";
export var sliderThumb = "_ca-3";
export var sliderTrack = "_ca-1";